module.exports = __webpack_public_path__ + "static/hero_filler_one-8155d53c98b138215699c9128ffaf7c0.png";